import React from 'react';
import { NavLink } from 'react-router-dom';

import {
  Icon,
  Flex,
  Avatar,
  Button,
  FlexProps,
  IconButton,
  AlertDialog,
} from 'common';

import { IRoute } from 'types';
import { useToast } from 'hooks';
import { useAppDispatch, useAppSelector } from 'store';
import { logoutThunk, selectCurrentUser } from 'store/user';
import { PADDING } from 'constants/sizes';
import { HeaderContext } from 'providers/header';

import { Container } from './styles';

const Navigation = ({ history }: { history: IRoute[] }) => {
  const flexProps: FlexProps = {
    flexDirection: 'row',
    alignItems: 'center',
    gap: PADDING.smallest,
    justifyContent: 'flex-start',
  };

  return (
    <Flex {...flexProps}>
      {history.map(({ title, path }, index) => {
        const label = title.toUpperCase();
        const key = `header-link-${title}`;

        if (index + 1 !== history.length) {
          return (
            <Flex {...flexProps} key={key}>
              <NavLink to={path} replace>
                <h2>{label}</h2>
              </NavLink>
              <Icon icon="chevron-right" />
            </Flex>
          );
        }

        return <h2 key={key}>{label}</h2>;
      })}
    </Flex>
  );
};

export const AppHeader = () => {
  const dispatch = useAppDispatch();
  const { handleFirebaseError } = useToast();

  const { state } = React.useContext(HeaderContext);
  const { current, history } = state;

  const [open, setOpen] = React.useState(false);
  const currentUser = useAppSelector(selectCurrentUser);

  const logout = async () => {
    try {
      await dispatch(logoutThunk());
    } catch (error) {
      handleFirebaseError(error);
    }
  };

  const ButtonComponent = () => {
    return (
      <Button
        type="button"
        palette="red"
        title="Logout"
        variant="default"
        onClick={logout}
      />
    );
  };

  return (
    <>
      <Container>
        {history && history.length > 1 ? (
          <Navigation history={history} />
        ) : (
          <h1>{current?.title.toUpperCase()}</h1>
        )}

        <Flex flexDirection="row" alignItems="center" gap={PADDING.biggest}>
          <IconButton icon="bell" disabled />
          <Avatar
            placeholderIcon="user"
            onClick={() => setOpen(true)}
            src={currentUser?.avatar?.original}
          />
        </Flex>
      </Container>

      <AlertDialog
        open={open}
        title="Logout"
        onClose={() => setOpen(false)}
        ButtonComponent={ButtonComponent}
        message="Are you sure you want to logout from platform?"
      />
    </>
  );
};
